import {
    invoke,
    checkPermissions as tauriCheckPermissions,
    requestPermissions as tauriRequestPermissions,
} from '@tauri-apps/api/core';

import { RenkiConfig, RenkiConfigUpdate } from './installationMetadata';

interface RenkiExtraPermission {
    wifiPermission: PermissionState;
}

interface MobileInfo {
    device: string;
    manufacturer: string;
    model: string;
    type: 'mobile';
}

interface DesktopInfo {
    cpu: string | null;
    model: string | null;
    name: string | null;
    os: string | null;
    product: string | null;
    ram: string | null;
    type: 'desktop';
}

export interface WifiStatus {
    bssid: string | null;
    frequency: string | null;
    ssid: string | null;
    vpn: boolean;
    wifi: boolean;
}

interface SaveKeyCloakTokens extends Record<string, unknown> {
    kcIdToken: string;
    kcRefreshToken: string;
    kcToken: string;
}

interface GetKeyCloakTokens {
    accessToken: string;
    idToken: string;
    refreshToken: string;
}

export type DeviceInfo = MobileInfo | DesktopInfo;

function saveKeyCloakTokens(tokens: SaveKeyCloakTokens) {
    return invoke('plugin:renkiextra|keycloak_save_tokens', tokens);
}

function getKeyCloakTokens(): Promise<GetKeyCloakTokens> {
    return invoke('plugin:renkiextra|keycloak_get_tokens');
}

function deleteKeyCloakTokens() {
    return invoke('plugin:renkiextra|keycloak_delete_tokens');
}

function checkPermissions() {
    return tauriCheckPermissions<RenkiExtraPermission>('renkiextra');
}

function requestPermissions() {
    return tauriRequestPermissions<RenkiExtraPermission>('renkiextra');
}

function getDeviceInfo() {
    return invoke<DeviceInfo>('plugin:renkiextra|device_info');
}

async function getWifiStatus() {
    await requestPermissions();
    return invoke<WifiStatus>('plugin:renkiextra|wifi_status');
}

function getIfAddresses() {
    return invoke<string[]>('get_if_addresses');
}

function refreshScan(token: string) {
    return invoke<boolean>('refresh_scan', { token });
}

function getOrCreateRenkiConfig(token: string) {
    return invoke<RenkiConfig>('get_or_create_renki_config', { token });
}

type Nullable<T> = { [K in keyof T]: T[K] | null };

function updateRenkiConfig(update: Nullable<RenkiConfigUpdate>): Promise<RenkiConfig> {
    return invoke('update_renki_config', { update });
}

export {
    checkPermissions,
    deleteKeyCloakTokens,
    getDeviceInfo,
    getIfAddresses,
    getKeyCloakTokens,
    getOrCreateRenkiConfig,
    getWifiStatus,
    refreshScan,
    requestPermissions,
    saveKeyCloakTokens,
    updateRenkiConfig,
};
